module.exports = __webpack_public_path__ + "img/阳光铝业.e56f8ee2.png";